import React, { FC } from "react";

import * as Illustrations from "./illustrations";

import { IllustrationProps, IllustrationNames } from "./types";

export const IllustrationContent: FC<IllustrationProps> = ({ name }) =>
  React.createElement(Illustrations[name as IllustrationNames]);
